var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#60C67C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3512 15.5254L20.8047 15.0875C21.2845 14.9432 21.8003 14.9782 22.2561 15.186C22.7119 15.3938 23.0765 15.7602 23.2819 16.2168L24.3009 18.4813C24.4778 18.8742 24.5271 19.3125 24.4419 19.7348C24.3567 20.1571 24.1413 20.5421 23.8259 20.8358L22.2748 22.2801C22.0669 22.4773 22.2245 23.2459 22.9839 24.5611C23.7441 25.8771 24.3317 26.3975 24.6026 26.3165L26.6347 25.6956C27.0466 25.5697 27.4876 25.5758 27.8959 25.7129C28.3042 25.8501 28.6593 26.1115 28.9114 26.4604L30.3597 28.4663C30.6523 28.8713 30.7877 29.3687 30.7409 29.866C30.6941 30.3633 30.4683 30.8268 30.1054 31.1702L28.9857 32.2298C28.6243 32.5718 28.1785 32.8119 27.6939 32.9256C27.2093 33.0393 26.7032 33.0225 26.2272 32.8769C23.8814 32.1593 21.709 30.0297 19.6806 26.5182C17.6478 23.0014 16.8801 20.035 17.4151 17.6115C17.5231 17.1232 17.7593 16.6724 18.0997 16.3057C18.44 15.9391 18.872 15.6697 19.3512 15.5254V15.5254Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalls);
export default __webpack_public_path__ + "static/media/calls.df713e7cafcde45bf3e5ab519b6bca60.svg";
export { ForwardRef as ReactComponent };